import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';

import { MatSelectChange } from '@angular/material/select';

import {
  CorreoElectronico,
  FormActionType
} from '@rpe/registro-personas-empresas-lib';
import { DireccionesGeograficasFormComponent } from '../../../ubicaciones/direcciones-geograficas/direcciones-geograficas-form/direcciones-geograficas-form.component';

import {
  PersonaFisicaFormInput,
  RPEPersonaFisica
} from '../entity-personas-fisica.model';
import { DocumentoPersonaFormComponent } from '../../../persona/documentos-persona/documento-persona-form/documento-persona-form.component';
import {
  DocumentoPersonaFormInput,
  DocumentoPersona
} from '../../../persona/documentos-persona/documentos-persona.model';
import { Subscription } from 'rxjs';
import { TelefonosFormComponent } from '../../../contactos/telefonos/components/telefonos-form.component';
import {
  Telefono,
  TelefonoFormInput
} from '../../../contactos/telefonos/telefonos.model';
import { DireccionGeografica } from '../../../ubicaciones/direcciones-geograficas/direcciones-geografica.model';
import { environment } from 'projects/registro-personas-empresas/src/environments/environment';
import { emailValidator } from 'projects/registro-personas-empresas/src/app/shared/validators/email-validators';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'rpe-persona-fisica-form',
  templateUrl: './persona-fisica-form.component.html',
  styleUrls: ['./persona-fisica-form.component.scss']
})
export class PersonaFisicaFormComponent implements OnInit, OnDestroy {
  @Input() set formInput(personaFisicaFormInput: PersonaFisicaFormInput) {
    this._formInput = personaFisicaFormInput;
    //this.direccionGeograficaFormInputTitular = personaFisicaFormInput.direccion_geografica;

    if (personaFisicaFormInput?.rol?.acreditacion_representacion) {
      this.acreditacionRepresentacionLink = `https://${environment.hostBackend}${personaFisicaFormInput.rol.acreditacion_representacion}`;
      this.acreditacionOculta = false;
    }

    if (personaFisicaFormInput.documento_persona) {
      this.documentoPersonaFormInput = {
        ...this.documentoPersonaFormInput,
        documento_persona: this.formInput.documento_persona,
        action: this.formInput.action
      };
    }

    if (!personaFisicaFormInput.documento_persona) {
      this.documentoPersonaFormInput = {
        ...this.documentoPersonaFormInput,
        action: personaFisicaFormInput.action
        //paises: personaFisicaFormInput.paises,
        //tipos_documento: personaFisicaFormInput.tipos_documento
      };
    }

    if (this.formInput.entidadProductiva) {
      if (this.formInput.entidadProductiva.direccion_geografica_constituida) {
        this.direccionGeograficaFormInput =
          this.formInput.entidadProductiva.direccion_geografica_constituida;
      }
    }
  }

  get formInput(): PersonaFisicaFormInput {
    return this._formInput;
  }

  acreditacionOculta = true;
  acreditacionRepresentacionLink: string = '';

  @Output() formStatusChanges = new EventEmitter<string>();
  @Output() formValueChangesRPEPF = new EventEmitter<RPEPersonaFisica>();

  // Direccion geografica
  @ViewChild(DireccionesGeograficasFormComponent, { static: true })
  direccionGeograficaForm: DireccionesGeograficasFormComponent;

  direccionGeograficaFormInputTitular: DireccionGeografica = null;

  direccionGeograficaFormInput: DireccionGeografica = null;
  direccionGeografica: DireccionGeografica = null;
  direccionGeograficaValid: boolean = false;

  @ViewChild(DocumentoPersonaFormComponent, { static: true })
  documentoPersonaForm: DocumentoPersonaFormComponent;

  @ViewChild(TelefonosFormComponent, { static: true })
  telefonosFormComponent: TelefonosFormComponent;
  formInputTelefono: TelefonoFormInput;
  telefonosStatus: string;
  telefonos: Telefono[];

  _formInput: PersonaFisicaFormInput = null;
  documentoPersonaFormInput: DocumentoPersonaFormInput = null;
  personaFisicaFormGroup: FormGroup;

  subscritions: Subscription[] = [];

  modificarParam: boolean = false;

  constructor(private fb: FormBuilder, private activatedRoute: ActivatedRoute) {
    this.modificarParam = this.activatedRoute.snapshot.queryParams.modificar;
  }

  ngOnInit(): void {
    // Creacion de nueva personaFisica
    if (this.formInput.action == FormActionType.Add) {
      this.formInputTelefono = {
        defaultPais: null,
        preSelectPais: 'uy',
        telefonos: null
      };
      this.personaFisicaFormGroup = this.fb.group({
        nombre_completo: ['', [Validators.required]],
        documento_persona: this.fb.array([
          this.documentoPersonaForm.createGroup()
        ]),

        entidad_productiva: this.fb.group({
          id: [null, []],
          rgs: [null, []],
          estado: [1, []], // EstadoEntidadProductiva
          autoregistrada: [true, []],
          correos_electronico: [null, []],
          direccion_geografica_constituida: null,
          direccion_geografica_correspondencia: null,
          direccion_geografica_fiscal: null,
          actividades: [[], []],
          persona_fisica_id: [null, []],
          persona_juridica_id: [null, []]
        }),
        rol: this.fb.group({
          persona_id: [this.formInput.id_persona_logueada, []], //aca va el id de la persona logueada
          entidad_productiva_id: [null, []],
          acreditacion_representacion: [null, [Validators.required]],
          es_creador: [true, []],
          fecha_alta: [new Date().toISOString().split('T')[0], []],
          fecha_baja: [null, []],
          vinculo_aprobado_rol: [true, []],
          vinculo_aprobado_entidad_productiva: [true, []],
          eliminado: [false, []],
          tipo_rol_id: [null, []]
        }),
        email_tecnico: this.fb.array([
          this.fb.control('', [Validators.required, emailValidator])
        ])
      });
    } else {
      this.formInputTelefono = {
        defaultPais: null,
        preSelectPais: 'uy',
        telefonos: this.formInput.entidadProductiva.telefonos
      };
      const emailTecnico =
        this._formInput.entidadProductiva.correos_electronico;
      const docFG = this.fb.group(this.formInput.documento_persona);

      this.personaFisicaFormGroup = this.fb.group({
        nombre_completo: [this.formInput.nombre_persona, [Validators.required]],
        // documento_persona: this.fb.array([this.fb.group(this.formInput.documento_persona)]),
        documento_persona: this.fb.array([
          this.documentoPersonaForm.createGroup()
        ]),
        entidad_productiva: this.fb.group(this.formInput.entidadProductiva),
        rol: this.fb.group(this.formInput.rol),
        email_tecnico:
          emailTecnico.length > 0
            ? this.fb.array(
                emailTecnico.map((ce) => {
                  return this.fb.control(ce.direccion, [
                    Validators.required,
                    emailValidator
                  ]);
                })
              )
            : this.fb.array([
                this.fb.control(null, [Validators.required, emailValidator])
              ])
      });

      if (this.modificarParam) {
        /// persona_juridica
        this.personaFisicaFormGroup.get('nombre_completo').disable();
        this.personaFisicaFormGroup.get('documento_persona').disable();

        /// roles
        this.personaFisicaFormGroup.get('rol').disable();
      }
    }

    // emit events
    const s1 = this.personaFisicaFormGroup.valueChanges.subscribe((_) => {
      this.onChangeFormEmit();
    });
    const s2 = this.personaFisicaFormGroup.statusChanges.subscribe((_) =>
      this.emitFormStatusChanges()
    );
    this.subscritions.push(s1, s2);
  }

  ngOnDestroy(): void {
    this.subscritions.forEach((s) => s.unsubscribe());
  }

  // Mails
  agregarOtroEmailTecnico() {
    this.email_tecnico.push(
      this.fb.control('', [Validators.required, emailValidator])
    );
  }
  eliminarUnEmailTecnico(index: number) {
    this.email_tecnico.removeAt(index);
  }
  get email_tecnico() {
    return this.personaFisicaFormGroup.get('email_tecnico') as FormArray;
  }

  cambioTipoRol(event: MatSelectChange) {
    let tipoRolId = event.value;
    // solo se muestra en caso de que sea apoderado 3 o representante 2 en otro caso se oculta
    this.acreditacionOculta = !(tipoRolId == 3 || tipoRolId == 2);

    if (this.acreditacionOculta) {
      // this.personaJuridicaFormGroup.get("rol").get("acreditacion_representacion").disable();
      this.personaFisicaFormGroup
        .get('rol')
        .get('acreditacion_representacion')
        .clearValidators();
    } else {
      // this.personaJuridicaFormGroup.get("rol").get("acreditacion_representacion").enable();
      this.personaFisicaFormGroup
        .get('rol')
        .get('acreditacion_representacion')
        .setValidators([Validators.required]);
    }
    this.personaFisicaFormGroup
      .get('rol')
      .get('acreditacion_representacion')
      .updateValueAndValidity();

    //si es titular se cargan los datos
    if (tipoRolId == 1) {
      this.personaFisicaFormGroup
        .get('nombre_completo')
        .setValue(this.formInput.nombre_persona);
      this.documentoPersonaForm.setValorDocumento(
        this.formInput.documento_persona
      );
      this.documentoPersonaForm.setSoloLectura(true);
      this.direccionGeograficaFormInput =
        this.direccionGeograficaFormInputTitular;
      this.personaFisicaFormGroup
        .get('entidad_productiva')
        ?.get('direccion_geografica_constituida')
        ?.setValue(this.direccionGeograficaFormInput);
      this.personaFisicaFormGroup
        .get('entidad_productiva')
        ?.get('direccion_geografica_correspondencia')
        ?.setValue(this.direccionGeograficaFormInput);
      this.personaFisicaFormGroup
        .get('entidad_productiva')
        ?.get('direccion_geografica_fiscal')
        ?.setValue(this.direccionGeograficaFormInput);
    } else {
      this.personaFisicaFormGroup.get('nombre_completo').setValue(null);
      // this.documentoPersonaForm.limpiarCampos();
      this.documentoPersonaForm.setSoloLectura(false);
    }
  }

  camposLectura() {
    let salida =
      this.personaFisicaFormGroup.get('rol').get('tipo_rol_id').value == 1;
    return salida;
  }

  ocultarAcreditacion() {
    return this.acreditacionOculta;
  }

  onChangeFormEmit() {
    let correos_electronico: CorreoElectronico[] = [];

    //voy tomando los correos y creo los tipos correspondientes
    let auxCorreos: string[] =
      this.personaFisicaFormGroup.get('email_tecnico').value;
    auxCorreos.forEach((direccion) => {
      let correo: CorreoElectronico = {
        id: null,
        direccion: direccion,
        tipo_correo_id: 3
      };
      correos_electronico.push(correo);
    });

    let auxDocumentos: any =
      this.personaFisicaFormGroup.get('documento_persona').value;
    let documento: DocumentoPersona = null;
    if (auxDocumentos) {
      documento = auxDocumentos[0];
    }

    this.formValueChangesRPEPF.emit({
      nombre_completo: this.personaFisicaFormGroup.get('nombre_completo').value,
      documento_persona: documento,
      entidad_productiva: {
        ...this.personaFisicaFormGroup.get('entidad_productiva').value,
        telefonos: this.telefonos,
        correos_electronico: correos_electronico,
        direccion_geografica_constituida: this.personaFisicaFormGroup
          .get('entidad_productiva')
          ?.get('direccion_geografica_constituida')?.value,
        direccion_geografica_correspondencia: this.personaFisicaFormGroup
          .get('entidad_productiva')
          ?.get('direccion_geografica_correspondencia')?.value,
        direccion_geografica_fiscal: this.personaFisicaFormGroup
          .get('entidad_productiva')
          ?.get('direccion_geografica_fiscal')?.value
      },
      rol: this.personaFisicaFormGroup.get('rol').value
    });
  }

  onFileChange(texto: string) {}

  reset(): void {}

  onShowErrors(): void {
    this.personaFisicaFormGroup.markAllAsTouched();
  }

  // Direccion Geografica
  direccionGeograficaChange(dg: any) {
    this.direccionGeografica = dg;
    this.personaFisicaFormGroup
      .get('entidad_productiva')
      ?.get('direccion_geografica_constituida')
      ?.setValue(this.direccionGeografica);
    this.personaFisicaFormGroup
      .get('entidad_productiva')
      ?.get('direccion_geografica_correspondencia')
      ?.setValue(this.direccionGeografica);
    this.personaFisicaFormGroup
      .get('entidad_productiva')
      ?.get('direccion_geografica_fiscal')
      ?.setValue(this.direccionGeografica);
  }

  direccionGeograficaStatusChange(s: any) {
    this.direccionGeograficaValid = s === 'VALID';
  }

  // Telefonos
  telefonoFormValueChange(telefonos: any) {
    this.telefonos = telefonos;
    this.onChangeFormEmit();
  }

  telefonoFormStatusChange(s: any) {
    this.telefonosStatus = s;
    this.emitFormStatusChanges();
  }

  emitFormStatusChanges() {
    const status =
      this.personaFisicaFormGroup.valid && this.telefonosStatus == 'VALID';
    this.formStatusChanges.emit(status ? 'VALID' : 'INVALID');
  }

  uploadNewAcreditacionRepresentacion(): void {
    this.acreditacionRepresentacionLink = '';
    this.personaFisicaFormGroup
      .get('rol')
      .get('acreditacion_representacion')
      .setValidators([Validators.required]);
    this.emitFormStatusChanges();
    this.onChangeFormEmit();
  }
}
